import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import DatumTree from '../Datum/Tree';
import shallowEqual from '../utils/shallowEqual';

function toArray(value) {
  if (!value) return [];
  if (!Array.isArray(value)) return [value];
  return value;
}

export default function datum(Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TreeDatum, _React$Component);

    var _super = _createSuper2(TreeDatum);

    function TreeDatum(props) {
      var _this;

      _classCallCheck(this, TreeDatum);

      _this = _super.call(this, props);
      _this.datum = void 0;
      _this.datum = new DatumTree({
        data: props.data,
        loader: props.loader,
        keygen: props.keygen,
        mode: props.mode,
        value: toArray(props.value),
        onChange: props.onChange,
        disabled: typeof props.disabled === 'function' ? props.disabled : undefined,
        childrenKey: props.childrenKey || 'children',
        unmatch: props.unmatch
      });
      return _this;
    }

    _createClass(TreeDatum, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!shallowEqual(prevProps.data, this.props.data)) {
          var disabled = this.props.disabled;
          this.datum.updateDisabled(typeof disabled === 'function' ? disabled : undefined);
          this.datum.setData(this.props.data, true);
          this.forceUpdate();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var value = this.props.value;

        var props = _objectSpread2(_objectSpread2({}, this.props), {}, {
          datum: this.datum
        });

        if (!shallowEqual(toArray(value), this.datum.getValue())) {
          this.datum.setValue(toArray(value));
        }

        return (
          /*#__PURE__*/
          React.createElement(Origin, props)
        );
      }
    }]);

    return TreeDatum;
  }(React.Component), _class.defaultProps = {
    mode: 1,
    childrenKey: 'children',
    unmatch: true
  }, _temp;
}